import img1 from "../../images/223.jpg";
import img2 from "../../images/322.jpg";
import img3 from "../../images/bg.jpg";

import euro from "../../images/icons/icon12.png";
import hydraeau from "../../images/icons/hydra-eau.png";
import men from "../../images/icons/icon14.png";
import time from "../../images/icons/time.png";
import users from "../../images/icons/users.png";
import IconsList2 from "../../pages/Carte/IconsList2";

const WaterLifecycle = () => {
  return (
    <div>
      <div className="container px-4 mx-auto mt-20 mb-10 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 mt-6 mb-6 md:grid-cols-2">
          <div className="flex flex-col ">
            <div>
              <h2 className="text-xl font-black text-left text-black">
                La petite station qui a tout d'une grande !
              </h2>
              <p className="mt-2 text-base text-left">
                La station, exploitée depuis 2022 par la SEVESC par le biais
                d'un contrat de délégation de service public (DSP), traite 4
                communes :
                <ul className="mt-5 ml-5 text-base list-disc">
                  <li>
                    En Réseau unitaire, c'est-à-dire eaux pluviales et eaux
                    usées « mélangées » : Les Clayes-sous-Bois et Villepreux.
                  </li>
                  <li>
                    En Réseau séparatif, c'est-à-dire uniquement des eaux usées
                    « strictes » : Noisy-le-Roi et Saint-Nom-la-Bretèche.
                  </li>
                </ul>
              </p>
              <div>
                <p className="mt-5 text-base">
                  Elle possède une capacité de 2 700 kg/DBO5 soit « 45 000
                  Équivalents Habitants », avec un débit de référence : 11 800
                  m3/j, dont un bassin tampon de 3 000 m3 avec une durée de
                  vidange en 24h. Le procédé de traitement des eaux usées de la
                  station est celui par « boue activée ».
                </p>
                <p className="mt-5 text-base">
                  Le bassin de stockage a été réalisé en 1999, la pose du
                  collecteur a été effectuée en 2000 et les travaux de la
                  nouvelle usine de traitement ont débuté en février 2000 pour
                  s'achever à l'été 2002. Enfin, début 2021, elle se voit
                  baptisée « Val de Gally », du nom du ruisseau le ru de Gally,
                  traversant Villepreux.
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <img
              src={img2}
              alt="Station Val de Gally"
              className="object-cover w-full h-64 rounded-lg sm:h-80 md:h-full"
            />
          </div>
        </div>

        <div className="grid items-center grid-cols-1 gap-6 mt-20 md:grid-cols-2">
          <div className="flex justify-center">
            <img
              src={img1}
              alt=""
              className="object-cover h-auto max-w-full rounded-lg "
            />
          </div>

          <div className="flex flex-col h-full">
            <div>
              <h2 className="text-xl font-bold text-left text-black">
                La protection de l'environnement
              </h2>
              <p className="mt-5 text-base text-left">
                L'usine de traitement des eaux usées du Val de Gally s'inscrit
                dans la politique de reconquête de la qualité du milieu naturel
                de la région. Le procédé mis en œuvre dans cette usine permet
                d'éliminer la pollution carbonée, azotée et phosphorée, générée
                par l'équivalent de 45 000 habitants, qu'elle soit d'origine
                domestique, pluviale ou industrielle. Les eaux, une fois
                dépolluées, sont rejetées dans le ru de Gally.
              </p>
              <p className="mt-5 text-base text-left">
                La prévention et le traitement des odeurs ont également fait
                l'objet d'un soin particulier, afin d'éviter des nuisances
                extérieures pour l'environnement de la station, mais aussi
                d'offrir au personnel des conditions de travail satisfaisantes.
                Le bâtiment, couvert et ventilé, ne rejette à l'extérieur que de
                l'air préalablement débarrassé de ses polluants.
              </p>
              <p className="mt-5 text-base text-left">
                Une attention particulière a été portée, lors de la conception
                de l'usine, à son intégration dans le paysage et à la compacité
                des ouvrages, avec une emprise minimum au sol. Inscrit dans un
                fond de vallée et surplombé par des coteaux, le site est
                particulièrement sensible aux vues lointaines. Il fait partie de
                la plaine de Versailles, site classé depuis juillet 2000.
              </p>
              <p className="mt-5 text-base text-left">
                L’aspect architectural et paysager a fait l’objet d’une
                concertation avec l’Architecte des Bâtiments de France et la
                Direction Régionale de l’Environnement. Les volumes et les
                toitures ont été traités à la manière d’une ferme, l’émergence
                des bassins a été limitée à 1 mètre et la totalité de l’espace
                compris entre le ru de Gally et les bâtiments a été engazonnée.
                Des arbres ont été plantés, des enrochements ont été réalisés
                sur les berges aux endroits où le courant est le plus fort et au
                droit du rejet, le reste des berges étant engazonné avec de
                nombreuses fleurs des champs.
              </p>
            </div>
          </div>
        </div>
      </div>

      <IconsList2
        headingTitle="Val de Gally en Chiffres"
        title1="Capacité de traitement"
        val1="45 000 eq/habitants"
        img1={users}
        title2="Communes"
        val2="4"
        img2={euro}
        title3="Capacité du bassin d’orage"
        val3="3000 m³ Un bassin tampon avec une durée de vidange en 24h"
        img3={hydraeau}
        title4="Réseau de transport connectés"
        val4="23 Km d'eaux usées et pluviales"
        img4={men}
        title5="Le site fonctionne"
        val5="24h/24"
        img5={time}
      />

      <div className="container px-4 mx-auto mt-10 mb-10 sm:px-6 lg:px-8">
        <img
          src={img3}
          alt="Val de Gally landscape"
          className="object-cover w-full h-64 rounded-lg sm:h-80 md:h-96"
        />
      </div>
    </div>
  );
};

export default WaterLifecycle;
